module.exports = __webpack_public_path__ + "img/8f6361bad3fa6e2d5c725562727b3ad7.png";